import { render, staticRenderFns } from "./Locator.vue?vue&type=template&id=4473603a&scoped=true"
import script from "./Locator.vue?vue&type=script&lang=js"
export * from "./Locator.vue?vue&type=script&lang=js"
import style0 from "./Locator.vue?vue&type=style&index=0&id=4473603a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4473603a",
  null
  
)

export default component.exports